import script from "./McpAgent.vue?vue&type=script&setup=true&lang=js"
export * from "./McpAgent.vue?vue&type=script&setup=true&lang=js"

import "./McpAgent.vue?vue&type=style&index=0&id=e766f4a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e766f4a4"]])

export default __exports__